import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CurrencyPricePipe } from '@delon/util';

interface DebitNotePreviewItem {
  accountCode: string;
  accountName: string;
  description: string;
  amount: number;
}

@Component({
  selector: 'app-transaction-preview-debit-note',
  standalone: true,
  imports: [CurrencyPricePipe, DecimalPipe],
  templateUrl: './transaction-preview-debit-note.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransactionPreviewDebitNoteComponent {
  @Input() currencyCode: string | null = null;
  @Input() items: DebitNotePreviewItem[] | null = null;
  @Input() totalAmount: number | null = null;
  @Input() taxableAmount: number | null = null;
  @Input() taxAmount: number | null = null;
  @Input() netTotal: number | null = null;
}
